import React from 'react';
import { isAppModule, isEiModule } from '@src/utils/constants';

const VideoBanner = () => {
  return (
    <div style={{ width: '50%' }}>
      {isAppModule && (
        <div
          style={{ position: 'relative', height: '100%', width: '100%' }}
          className="color-critical"
        >
          <iframe
            src="https://player.vimeo.com/video/1121562628?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            title="Nexa_App"
          ></iframe>
        </div>
      )}

      {isEiModule && (
        <div
          style={{ position: 'relative', height: '100%', width: '100%' }}
          className="color-critical"
        >
          <iframe
            src="https://player.vimeo.com/video/1121570200?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            title="Nexa_sei"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default VideoBanner;
